import { render, staticRenderFns } from "./editCompliance.vue?vue&type=template&id=2abbb5f6&"
import script from "./editCompliance.vue?vue&type=script&lang=js&"
export * from "./editCompliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports